import { ComponentType, EventSource, InteractionType, MixpanelEvent } from '../MixPanelTypes';

export type DailyBriefingEvents = 'OPEN' | 'GENERATE' | 'OPEN_REFERENCE';

export const dailyBriefing: Record<DailyBriefingEvents, MixpanelEvent> = {
  OPEN: {
    eventDescription: 'Daily Briefing Panel Open',
    eventKey: 'daily-briefing-open',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.APP_TOOLBAR_BUTTON
  },
  GENERATE: {
    eventDescription: 'Daily Briefing Generate',
    eventKey: 'daily-briefing-generate',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.PRIMARY_ACTION
  },
  OPEN_REFERENCE: {
    eventDescription: 'Daily Briefing Open Reference',
    eventKey: 'daily-briefing-open-reference',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.INTERNAL_LINK_BUTTON
  }
} as const;

export type DailyBriefingGenerateSource = 'prompt' | 'suggestion' | 'overview';

// Analytics payloads deliberately carry no PII — no prompt text, no uids.
export type DailyBriefingGenerateDetails = {
  source: DailyBriefingGenerateSource;
  hasPrompt: boolean;
};

export type DailyBriefingOpenReferenceDetails = {
  referenceType: string;
};
